import ProjectCard from "./ProjectCard";

const Project = ({Data,show,col=0}) => {
    return (
        <div className={col==2?`sm:grid sm:grid-cols-2 gap-4`: (col==3?"sm:grid sm:grid-cols-3 gap-4":"")}>
            {Data && Data.slice(0,show).map(Element => (
                <ProjectCard key={Element.title} title={Element.title} gif={Element.hoverCover} url={Element.external} cover={Element.cover}/>
            ))}
        </div>
    );
}
 
export default Project;